import {api, getFileStream} from '@/api/client';
import { config } from '@/config/env';
import useCounterStore from "@/store";
// 获取团队信息鉴权
export const teamInfo = () =>
    api.get(`/v1/admin/team/info`, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });

//获取
export const getTopicDetail = (topicNo:string) =>
    api.get(`/v1/admin/topic/detail`, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        params: {
            topicNo: topicNo,
        },
    });


